import LaborDetail1 from "./components/LaborDetail1.vue";
import LaborDetail2 from "./components/LaborDetail2.vue";
import LaborDetail3 from "./components/LaborDetail3.vue";
import LaborDetail4 from "./components/LaborDetail4.vue";
import LaborDetail5 from "./components/LaborDetail5.vue";
import LaborDetail6 from "./components/LaborDetail6.vue";
import LaborDetail7 from "./components/LaborDetail7.vue";
import LaborDetail8 from "./components/LaborDetail8.vue";
import LaborDetail9 from "./components/LaborDetail9.vue";
import LaborDetail10 from "./components/LaborDetail10.vue";
import LaborDetail11 from "./components/LaborDetail11.vue";
export default {
  components: {
    LaborDetail1,
    LaborDetail2,
    LaborDetail3,
    LaborDetail4,
    LaborDetail5,
    LaborDetail6,
    LaborDetail7,
    LaborDetail7,
    LaborDetail8,
    LaborDetail9,
    LaborDetail10,
    LaborDetail11
  },
  props: {
    laboratoryItemDetail: {
      type: Object,
      default: {}
    },
    specialtyId: {
      type: String,
      default: ''
    },
    specialtyTermId: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      activeItem: "laborDetail1",
      menuList: {
        laborDetail1: {
          name: "项目描述",
          id: "laborDetail1",
          bolshow: true
        },
        laborDetail2: {
          name: "项目团队",
          id: "laborDetail2",
          bolshow: true
        },
        laborDetail3: {
          name: "网络要求",
          id: "laborDetail3",
          bolshow: true
        },
        laborDetail4: {
          name: "实验项目",
          id: "laborDetail4",
          bolshow: true
        },
        laborDetail5: {
          name: "项目特色",
          id: "laborDetail5",
          bolshow: true
        },
        laborDetail6: {
          name: "服务计划",
          id: "laborDetail6",
          bolshow: true
        },
        laborDetail7: {
          name: "知识产权",
          id: "laborDetail7",
          bolshow: true
        },
        laborDetail8: {
          name: "附件材料",
          id: "laborDetail8",
          bolshow: true
        },
        laborDetail9: {
          name: "承诺意见",
          id: "laborDetail9",
          bolshow: true
        },
        laborDetail10: {
          name: "优秀案例",
          id: "laborDetail10",
          bolshow: true
        },
        laborDetail11: {
          name: "实验记录",
          id: "laborDetail11",
          bolshow: true
        }
      },
      menuListTrue: [],
      // 附件材料
      fileList: [],
      // 优秀案例
      caseList: [],
      // 实验记录
      recordOrginList: []
    };
  },

  watch: {
    menuList: {
      handler(newval, oldval) {
        if (newval) {
          const currentItem = Object.values(newval).find(item => item.bolshow);

          if (currentItem && currentItem.id) {
            this.activeItem = currentItem.id;
          } else {
            this.activeItem = "laborDetail1";
          }

          const menuListTrueArr = [];
          Object.values(newval).forEach(item => {
            if (item.bolshow) {
              menuListTrueArr.push(item);
            }
          });
          this.menuListTrue = menuListTrueArr;
        }
      },

      deep: true,
      immediate: true
    },

    laboratoryItemDetail(newval, oldval) {
      if (newval) {
        // 附件材料
        this.getFileList(newval.id); // 优秀案例

        this.getCaseList(newval.id); // 实验记录

        this.getOrginRecordList(newval.id);
      }
    }

  },
  computed: {
    computedPreHash() {
      let queryStr = "";

      if (this.$route.query && Object.keys(this.$route.query).length > 0) {
        for (var i in this.$route.query) {
          queryStr = queryStr + "&" + i + "=" + this.$route.query[i];
        }

        queryStr = queryStr.substr(1);
        return this.$route.path + "?" + queryStr;
      } else {
        return this.$route.path;
      }
    },

    computedShowLaborDetail1() {
      if (this.laboratoryItemDetail.experiment_purpose || this.laboratoryItemDetail.period || this.laboratoryItemDetail.experiment_theory || this.laboratoryItemDetail.experiment_equipment || this.laboratoryItemDetail.experiment_method || this.laboratoryItemDetail.experiment_step || this.laboratoryItemDetail.experiment_result || this.laboratoryItemDetail.experiment_check || this.laboratoryItemDetail.experiment_stu_check || this.laboratoryItemDetail.experiment_state) {
        this.menuList.laborDetail1 = { ...this.menuList["laborDetail1"],
          bolshow: true
        };
        return true;
      } else {
        this.menuList.laborDetail1 = { ...this.menuList["laborDetail1"],
          bolshow: false
        };
        return false;
      }
    },

    // TODO:可继续展开
    computedShowLaborDetail2() {
      if (this.laboratoryItemDetail.id) {
        this.menuList.laborDetail2 = { ...this.menuList["laborDetail2"],
          bolshow: true
        };
        return true;
      } else {
        this.menuList.laborDetail2 = { ...this.menuList["laborDetail2"],
          bolshow: false
        };
        return false;
      }
    },

    computedShowLaborDetail3() {
      if (this.laboratoryItemDetail.net_link || this.laboratoryItemDetail.net_require || this.laboratoryItemDetail.net_os || this.laboratoryItemDetail.net_software_require || this.laboratoryItemDetail.net_hardware_require || this.laboratoryItemDetail.net_hardware_other_require || this.laboratoryItemDetail.net_safe) {
        this.menuList.laborDetail3 = { ...this.menuList["laborDetail3"],
          bolshow: true
        };
        return true;
      } else {
        this.menuList.laborDetail3 = { ...this.menuList["laborDetail3"],
          bolshow: false
        };
        return false;
      }
    },

    computedShowLaborDetail4() {
      if (this.laboratoryItemDetail.tech_project) {
        this.menuList.laborDetail4 = { ...this.menuList["laborDetail4"],
          bolshow: true
        };
        return true;
      } else {
        this.menuList.laborDetail4 = { ...this.menuList["laborDetail4"],
          bolshow: false
        };
        return false;
      }
    },

    computedShowLaborDetail5() {
      if (this.laboratoryItemDetail.materials_feature) {
        this.menuList.laborDetail5 = { ...this.menuList["laborDetail5"],
          bolshow: true
        };
        return true;
      } else {
        this.menuList.laborDetail5 = { ...this.menuList["laborDetail5"],
          bolshow: false
        };
        return false;
      }
    },

    computedShowLaborDetail6() {
      if (this.laboratoryItemDetail.materials_plan) {
        this.menuList.laborDetail6 = { ...this.menuList["laborDetail6"],
          bolshow: true
        };
        return true;
      } else {
        this.menuList.laborDetail6 = { ...this.menuList["laborDetail6"],
          bolshow: false
        };
        return false;
      }
    },

    computedShowLaborDetail7() {
      if (this.laboratoryItemDetail.materials_property) {
        this.menuList.laborDetail7 = { ...this.menuList["laborDetail7"],
          bolshow: true
        };
        return true;
      } else {
        this.menuList.laborDetail7 = { ...this.menuList["laborDetail7"],
          bolshow: false
        };
        return false;
      }
    },

    computedShowLaborDetail8() {
      if (this.fileList && Array.isArray(this.fileList) && this.fileList.length > 0) {
        this.menuList.laborDetail8 = { ...this.menuList["laborDetail8"],
          bolshow: true
        };
        return true;
      } else {
        this.menuList.laborDetail8 = { ...this.menuList["laborDetail8"],
          bolshow: false
        };
        return false;
      }
    },

    computedShowLaborDetail9() {
      if (this.laboratoryItemDetail.materials_comment) {
        this.menuList.laborDetail9 = { ...this.menuList["laborDetail9"],
          bolshow: true
        };
        return true;
      } else {
        this.menuList.laborDetail9 = { ...this.menuList["laborDetail9"],
          bolshow: false
        };
        return false;
      }
    },

    computedShowLaborDetail10() {
      if (this.caseList && Array.isArray(this.caseList) && this.caseList.length > 0) {
        this.menuList.laborDetail10 = { ...this.menuList["laborDetail10"],
          bolshow: true
        };
        return true;
      } else {
        this.menuList.laborDetail10 = { ...this.menuList["laborDetail10"],
          bolshow: false
        };
        return false;
      }
    },

    computedShowLaborDetail11() {
      if (this.recordOrginList && Array.isArray(this.recordOrginList) && this.recordOrginList.length > 0) {
        this.menuList.laborDetail11 = { ...this.menuList["laborDetail11"],
          bolshow: true
        };
        return true;
      } else {
        this.menuList.laborDetail11 = { ...this.menuList["laborDetail11"],
          bolshow: false
        };
        return false;
      }
    }

  },
  methods: {
    onAnchorClick(e, {
      href
    }) {
      this.activeItem = href && href.split("#").pop() || "laborDetail1";
    },

    onAnchorChange(link) {
      this.activeItem = link && link.split("#").pop() || "laborDetail1";
    },

    /* 附件材料 */
    async getFileList(vr_id) {
      const data = await this.$http.getAttachmentPageByParam({
        vr_id: vr_id
      });
      this.fileList = data.content;
    },

    /* 优秀案例 */
    async getCaseList(vr_id) {
      const data = await this.$http.getVRCasePageByParam({
        vr_id: vr_id
      });
      this.caseList = data.content;
    },

    /* 实验记录 */
    async getOrginRecordList(vr_id) {
      const data = await this.$http.getVRRecordPageByParam({
        vr_id: vr_id,
        record_name: "",
        user_name: ""
      });
      this.recordOrginList = data.content;
    }

  }
};